import React, { lazy, Suspense } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { connect } from 'react-redux'
import store from 'store'
import Layout from 'layouts'
import ACL from 'components/system/ACL'
import Common from 'services/common'

// const SelectedCluster = localStorage.getItem('SelectedCluster')
//   ? JSON.parse(localStorage.getItem('SelectedCluster'))
//   : null
// const clusterId = SelectedCluster !== null ? SelectedCluster.clusterId : ''
// const eulaComp = lazy(() => import('components/common/eula-content'))
const routes = [
  {
    path: '/:clusterId/:scopeId?/admin/clusters',
    key: 'admin',
    Component: lazy(() => import('pages/admin/cluster/clusterList')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/admin/clusters/configure/:id?',
    key: 'admin',
    Component: lazy(() => import('pages/admin/cluster/clusterConnect/coreconnect.js')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/admin/components',
    key: 'admin',
    Component: lazy(() => import('pages/admin/component')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/admin/components/:type/:id/health',
    key: 'admin',
    Component: lazy(() => import('pages/admin/component/component-health')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/admin/components/:type/:id/configure',
    key: 'admin',
    Component: lazy(() => import('pages/admin/component/config.js')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/admin/global/:option?',
    key: 'global_views',
    Component: lazy(() => import('pages/admin/global_views')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - No Access',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
      'User - No Access',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/admin/smtp',
    key: 'system',
    Component: lazy(() => import('pages/admin/smtp')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/admin/compute-policy',
    key: 'system',
    Component: lazy(() => import('pages/admin/compute_policy')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/admin/switchboard',
    key: 'admin',
    Component: lazy(() => import('pages/system/switch_board')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/admin/organizations/list',
    key: 'admin',
    Component: lazy(() => import('pages/admin/Organisations')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/admin/user/list',
    key: 'admin',
    Component: lazy(() => import('pages/admin/user-management')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/admin/user/:id?',
    key: 'admin',
    Component: lazy(() => import('pages/admin/user-management/add-edit-user')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
    ],
    exact: true,
  },
  {
    path: '/auth/login',
    key: 'login',
    Component: lazy(() => import('components/system/Auth')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
      'User - Viewer',
      'User - No Access',
      '',
    ],
    exact: true,
  },
  {
    path: '/auth/login/verify-otp',
    key: 'OTPValidation',
    Component: lazy(() => import('components/system/Auth/VerifyOTP')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
      'User - Viewer',
      'User - No Access',
      '',
    ],
    exact: true,
  },
  {
    path: '/auth/reset-password/:token',
    key: 'resetPass',
    Component: lazy(() => import('components/system/Auth/ResetPassword')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
      'User - Viewer',
      'User - No Access',
      '',
    ],
    exact: true,
  },
  {
    path: '/auth/set-password/:token',
    key: 'setPass',
    Component: lazy(() => import('components/system/Auth/SetPassword')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
      'User - Viewer',
      'User - No Access',
      '',
    ],
    exact: true,
  },
  {
    // path: '/:clusterId/:scopeId/auth/404',
    path: '/auth/404',
    key: '404',
    Component: lazy(() => import('pages/auth/404')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
      'User - Viewer',
      'User - No Access',
      '',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/auth/500',
    key: '500',
    Component: lazy(() => import('pages/auth/500')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
      'User - Viewer',
      'User - No Access',
      '',
    ],
    exact: true,
  },
  {
    path: '/:clusterId?/:scopeId?/no-access/auth/no-access',
    key: 'noAccess',
    Component: lazy(() => import('pages/auth/no-access')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
      'User - Viewer',
      'User - No Access',
      '',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/dashboard',
    key: 'dashboard',
    Component: lazy(() => import('pages/dashboard/list')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
      'User - Viewer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/system/slow-queries',
    key: 'slowQuery',
    Component: lazy(() => import('pages/longquerymgmt/')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/dashboard/:type',
    key: 'dashboard',
    Component: lazy(() => import('pages/dashboard/view')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
      'User - Viewer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scope_id/:ID/reportlink/:theme?/:licensetype?',
    key: 'reportprint',
    Component: lazy(() => import('pages/reports/view/list.js')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'Admin - No Access',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
      'User - Viewer',
      'User - No Access',
      '',
    ],
    exact: true,
  },

  {
    path: '/:clusterId/:scopeId?/reports',

    key: 'reportslist',
    Component: lazy(() => import('pages/reports/list')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
    ],
    exact: true,
  },
  {
    // path: "/:clusterId/reports/:type",
    path: '/:clusterId/:scope_id/reports/:type',
    key: 'reportsview',
    Component: lazy(() => import('pages/reports/view/list.js')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
    ],
    exact: true,
  },

  {
    // path: '/:clusterId/:scope_id/:SSID/reports/:type',
    path: '/:clusterId/:scope_id/reports/:type',
    key: 'demoreportsview',
    Component: lazy(() => import('pages/reports/view')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'Admin - Viewer',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
    ],
    exact: true,
  },

  {
    path: '/:clusterId/:scopeId?/system/eventstores',
    key: 'eventstore',
    Component: lazy(() => import('pages/eventstore')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/system/utilization',
    key: 'utilization',
    Component: lazy(() => import('pages/usagepage')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/jobs/scheduled',
    key: 'scheduled',
    Component: lazy(() => import('pages/jobs/scheduled_jobs/index')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/jobs/signals',
    key: 'jobs',
    Component: lazy(() => import('pages/jobs/signals/')),
    roles: [
      'Admin - Security Engineer',
      'Admin - Security Analyst',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
      'User - Security Analyst',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/system/models',
    key: 'system',
    Component: lazy(() => import('pages/admin/models')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/system/models/:type/:name?',
    key: 'system',
    Component: lazy(() => import('pages/admin/models/YAMLform.js')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/incident/signals',
    key: 'incident_signals',
    Component: lazy(() => import('pages/incidents/signal-analyzer')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/incident/cases',
    key: 'incident_cases',
    Component: lazy(() => import('pages/incidents/cases')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/incident/cases/:type',
    key: 'cases',
    Component: lazy(() => import('pages/incidents/cases/cases-analyzer')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/stream/list',
    key: 'streams',
    Component: lazy(() => import('pages/stream')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/system/collection_status',
    key: 'streams',
    Component: lazy(() => import('pages/devicemgmt/deviceList')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/system/extraction',
    key: 'system',
    Component: lazy(() => import('pages/admin/Extraction')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/system/extraction/:type/:name?',
    key: 'system',
    Component: lazy(() => import('pages/admin/Extraction/YAMLform.js')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/system/enrichment',
    key: 'system',
    Component: lazy(() => import('pages/admin/Enrichment')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/system/enrichment/:type/:name?',
    key: 'system',
    Component: lazy(() => import('pages/admin/Enrichment/YamlForm.js')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/system/signalsuppression',
    key: 'system',
    Component: lazy(() => import('pages/system/falsepositive')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/system/geodb',
    key: 'system',
    Component: lazy(() => import('pages/admin/geodb')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/system/integrations',
    key: 'integrations',
    Component: lazy(() => import('pages/admin/integrations/')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/system/components',
    key: 'secadmin',
    Component: lazy(() => import('pages/system/cust_admin')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/system/components/:type/:id/health',
    key: 'secadmin',
    Component: lazy(() => import('pages/admin/component/component-health')),
    // Component: lazy(() => import('pages/system/cust_admin/component-health')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/system/components/:type/:id/configure',
    key: 'secadmin',
    Component: lazy(() => import('pages/admin/component/config')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/system/token',
    key: 'system',
    Component: lazy(() => import('pages/admin/tokenManagement')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/eba',
    key: 'eba',
    Component: lazy(() => import('pages/uba')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Engineer',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/home/:view?/:id?',
    key: 'home',
    Component: lazy(() => import('pages/home')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
    ],
    exact: true,
    productTypes: ['essential', 'professional', 'enterprise'],
  },
  {
    path: '/:clusterId/:scopeId?/workbook',
    key: 'workbook',
    Component: lazy(() => import('pages/workbook/workbookList')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/workbook/:type/:data?',
    key: 'workbookView',
    Component: lazy(() => import('pages/workbook/workbookView')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
    ],
    exact: true,
  },
  {
    path: '/:clusterId/:scopeId?/mitre_attack',
    key: 'mitre_attack',
    Component: lazy(() => import('pages/apt_monitoring')),
    roles: [
      'Admin - Security Engineer',
      'Admin - SecAdmin Security Engineer',
      'Admin - Security Analyst',
      'User - Security Engineer',
      'User - SecAdmin Security Engineer',
      'User - Security Analyst',
    ],
    exact: true,
  },
]

const mapStateToProps = ({ settings, user }) => ({
  routerAnimation: settings.routerAnimation,
  selectedCluster: user.selectedCluster,
  selectedScope: user.selectedScope,
})

@connect(mapStateToProps)
class Router extends React.Component {
  render() {
    const { history, routerAnimation } = this.props
    var loginstatus = localStorage.getItem('loginStatus')
    // var eulastatus = localStorage.getItem('eulaStatus')
    var link = 'auth/login'
    const SelectedAcc = Common.decryptData(localStorage.getItem('userPayload'))
    const clusterId = SelectedAcc !== null ? SelectedAcc.clusterId : ''
    const scopeId = SelectedAcc !== null ? SelectedAcc.scope_id : ''
    // var accessData = JSON.parse(localStorage.getItem('accessData'))
    if (loginstatus === 'success') {
      link = history.location.pathname
    }
    return (
      <ConnectedRouter history={history}>
        <Layout>
          <Route
            render={state => {
              const { location } = state
              return (
                <SwitchTransition>
                  <CSSTransition key={location.pathname}
                    appear
                    classNames={routerAnimation}
                    timeout={routerAnimation === 'none' ? 0 : 300}>
                    <Switch location={location}>
                      <Route
                        exact
                        path="/"
                        render={props => {
                          return (
                            <div>
                              {!window.location.toString().includes('/reportlink/') && (
                                <>
                                  {localStorage.getItem('IsInvalid') === 'true' ? (
                                    <Redirect to="/auth/login" />
                                  ) : Common.decryptData(localStorage.getItem('UserAcc'), true) === 'Admin - No Access' ? (
                                    <Redirect to={`/${clusterId}/admin/components`} />
                                  ) : (
                                    <Redirect to={`/${clusterId}/${scopeId}/workbook/new`} />
                                  )}
                                </>
                              )}
                            </div>
                          )
                        }}
                      />
                      {routes.map(({ path, key, Component, exact, roles }) => (
                        <Route
                          path={path}
                          key={path}
                          exact={exact}
                          render={props => {
                            store.set('app.menu.selectedKeys', [key])
                            return (
                              <div className={routerAnimation}>
                                <ACL roles={roles} redirect={link}>
                                  <Suspense fallback={null}>
                                    <Component />
                                  </Suspense>
                                </ACL>
                              </div>
                            )
                          }}
                        />
                      ))}

                      {/* {clusterId === '' && scopeId === '' ? (
                        <Redirect to={`/auth/no-access`} />
                      ) : ( */}
                      <Redirect to={`/auth/404`} />
                      {/* )} */}
                    </Switch>
                  </CSSTransition>
                </SwitchTransition>
              )
            }}
          />
        </Layout>
      </ConnectedRouter>
    )
  }
}

export default Router
